<h1 mat-dialog-title>Remove Asset(s)</h1>
<div mat-dialog-content>
    <table>
        <tr>
            <td>
                <button mat-stroked-button color="accent" [mat-dialog-close]="false">Remove</button>
            </td>
            <td>the selected {{ data.length }} asset(s) from the current Stream</td>
        </tr>
        <tr>
            <td>
                <button mat-stroked-button color="warn" [mat-dialog-close]="true">Delete</button>
            </td>
            <td>the selected {{ data.length }} asset(s) from all Streams</td>
        </tr>
    </table>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="null">Cancel</button>
</div>
